import React, { useEffect, useCallback, useState } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, message, Modal } from "antd";
import GenerateTabContent from "./GenerateTabContent";
import {
  SaveButton,
  NextButton,
  ResetButton,
} from "../../../components/common/Button";
import { TEXT_CONSTANTS } from "../../../constants/Constants";

import {
  API_ENDPOINT_ADDORUPDATE,
  API_ENDPOINT_GOALSDATA,
  API_ENDPOINT_PILLARDATA,
  API_HEADER_AUTH,
  API_METHOD_DELETE,
  API_METHOD_GET,
} from "../../../constants/apiConstant";

import { apiRequest, API_BASE_URL } from "../../../services/apiService";
import {
  setGoalsQuestions,
  setGoalsAnswer,
  setActiveTabKey,
  setIsSaved,
  setGoalsPillarsStatus
} from "../../../redux/slices/supplierGoalsSlice";
import { MODAL_MESSAGES, RESET_MESSAGES, SAVE_MESSAGES } from '../../../constants/messages';
import axios from "axios";
import { handleDownloadPDF } from "../../../util/pdfUtils";
import "./Goals.css";
import { CheckCircleOutlined } from '@ant-design/icons'

const Goals = () => {
  const [pagePermission, setPagePermission] = useState({});

  useEffect(() => {
    const permission = sessionStorage.getItem('UserPermission');
    console.log( permission);
    
      const parsedPermissions = JSON.parse(permission);
      console.log(parsedPermissions['GOALS']);
      
      setPagePermission(parsedPermissions);

  }, []);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { goalsQuestions, activeTabKey, goalsAnswer, isSaved, goalsPillarsStatus } = useSelector(
    (state) => state.goals
  );
  const token=sessionStorage.getItem("authToken")
  const supplierId=sessionStorage.getItem("supplierId")
console.log("from goals",supplierId)

  useEffect(() => {
    const fetchGoalsQuestion = async () => {
      try {
       
        
        const result = await apiRequest(API_METHOD_GET, API_ENDPOINT_GOALSDATA);
        dispatch(setGoalsQuestions(result));
      } catch (error) {
        console.error("Error fetching page content:", error);
      }
    };
    
    const checkingGolasPillarStatus = (goalsAnswer) => {
      const pillarStatus = {};
      goalsAnswer.map((pillar)=>{
        if(pillar){
          const {pillarName, goalAnswers} = pillar;
          goalAnswers && goalAnswers.map((goalAnswer)=> {
            if(goalAnswer.response.length){
              pillarStatus[pillarName] = true
            } else {
              pillarStatus[pillarName] = false
            }
          })
        }
      })
      return pillarStatus;
    }
    
    const fetchGoalsAnswer = async () => {
      try {
        const result =
          (await apiRequest(API_METHOD_GET, API_ENDPOINT_PILLARDATA+supplierId,API_HEADER_AUTH)) || [];
        const pillarStatus = checkingGolasPillarStatus(result)
        dispatch(setGoalsPillarsStatus({...goalsPillarsStatus,...pillarStatus}))
        dispatch(setGoalsAnswer(result));
      } catch (error) {
        console.error("Error fetching page content:", error);
      }
    };

    fetchGoalsQuestion();
    fetchGoalsAnswer();
  }, [dispatch, loading]);

  const validatePillarData = (pillarName) => {
    const findInputFields = (questionId) => {
      const pillarData = goalsQuestions?.find(que => que.pillarName === pillarName);
      if (!pillarData) return null;
      
      const question = pillarData.questions?.find(que => que.questionId === questionId);
      return question?.inputFields || [];
    };

    const pillarAnswers = goalsAnswer?.find(pillar => pillar.pillarName === pillarName)?.goalAnswers;
    if (!pillarAnswers) return false;

    return pillarAnswers.every(answer => {
      const inputFields = findInputFields(answer.questionId);
      if (!inputFields) return false;

      return inputFields.every(inputField => {
        const response = answer.response?.find(resp => resp.fieldId === inputField.inputId);
        return response && response.value.trim() !== "";
      });
    });
  };

  const handleTabChange = (newTabKey) => {
    const isCurrentPillarValid = validatePillarData(activeTabKey);
    
    if (!isCurrentPillarValid) {
      message.warning("Please fill all required fields in the current pillar before switching.");
      return;
      Modal.confirm({
        title: MODAL_MESSAGES.confirmNextPage.DataNotSavedtab,
        onOk() {
          dispatch(setActiveTabKey(newTabKey));
        },
      });
    }
    else{
      Modal.confirm({
        title: MODAL_MESSAGES.confirmNextPage.tabBar,
        onOk() {
          dispatch(setActiveTabKey(newTabKey));
        },
      });
    }
    
    
   
  };

  const saveValidation = (pillarName) => {
    return validatePillarData(pillarName);
  };

  const resetGoals = async (supplierId, pillarName) => {
    const endpoint = `/goals/reset?supplierId=${supplierId}&pillarName=${pillarName}`;

    Modal.confirm({
      title: RESET_MESSAGES.title,
      content: RESET_MESSAGES.content,
      okText: RESET_MESSAGES.okText,
      okType: RESET_MESSAGES.okType,
      cancelText: RESET_MESSAGES.cancelText,
      onOk: async () => {
        try {
          setLoading(true);
          const result = await apiRequest(API_METHOD_DELETE, endpoint);
          message.success(`${pillarName} Data reset successfully!`);
          dispatch(setActiveTabKey(pillarName));
          dispatch(setGoalsPillarsStatus(false))
        } catch (error) {
          console.error(
            "Error deleting goals:",
            error.response ? error.response.data : error.message
          );
          dispatch(setGoalsPillarsStatus(true))
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const saveOrUpdateGoalData = useCallback(
    async (pillarName) => {
      const pillar = goalsAnswer.find((item) => item.pillarName === pillarName);
      if (!pillar) {
        console.error(`Pillar "${pillarName}" not found.`);
        return;
      }

      let valid = saveValidation(pillarName);

      if (!valid) {
        message.error(SAVE_MESSAGES.validAlert);
        return;
      }

      const url = `${API_BASE_URL}${API_ENDPOINT_ADDORUPDATE}`;

      Modal.confirm({
        title: SAVE_MESSAGES.title,
        content: SAVE_MESSAGES.content,
        okText: SAVE_MESSAGES.okText,
        cancelText: SAVE_MESSAGES.cancelText,
        onOk: async () => {
          try {
            const response = await axios.post(url, pillar, {headers: {
              Authorization: `Bearer ${sessionStorage.getItem("authToken") || ""}`,
              "Content-Type": "application/json"
          }});
            setLoading(!loading);
            dispatch(setIsSaved(true));
            message.success(`${pillarName} Data saved successfully!`);
          } catch (error) {
            console.error(
              "Error saving/updating data:",
              error.response ? error.response.data : error.message
            );
            message.error("Failed to save data.");
          }
        },
      });
    },
    [dispatch, goalsAnswer, loading]
  );

  const downloadPDF = async () => {
    if(pagePermission["GOALS_DOWNLOAD"]){
      handleDownloadPDF(supplierId, setLoading, (data) => {});
    }else{
      message.warning("You Do not have Access");
    }
 
  };

  const handleNextClick = useCallback(() => {
    const isCurrentPillarValid = validatePillarData(activeTabKey);
    
    if (!isCurrentPillarValid) {
      message.warning("Please fill all required fields in the current pillar before proceeding.");
      return;
    }

    const currentIndex = goalsQuestions.findIndex(
      (item) => item.pillarName === activeTabKey
    );
    const nextIndex = (currentIndex + 1) % goalsQuestions.length;
    dispatch(setActiveTabKey(goalsQuestions[nextIndex].pillarName));
  }, [dispatch, goalsQuestions, activeTabKey]);

  const items = goalsQuestions.map((pillar) => ({
    key: pillar.pillarName,
    label: <span className="text-[14px]">{pillar.pillarName}{goalsPillarsStatus[pillar.pillarName] && <CheckCircleOutlined className='text-[#52c41a] text-[15px] p-2' />}</span>,
    children: <GenerateTabContent Data={pillar} supplierId={supplierId} />,
  }));

  if(pagePermission["GOALS"]===false){
    console.log(pagePermission["GOALS"]);
    
    return <div>You do not have permission to access the Goals page.</div>;
  }

  return (
    <div className="p-0 sm:p-4">
      <div className="flex justify-end mb-2">
          <Button
            onClick={downloadPDF}
            className="bg-[#2C5778] text-white border-[#2C5778] h-8 rounded-lg mr-2"
          >
            {TEXT_CONSTANTS.PDF_DOWNLOAD}
          </Button>
      </div>
      <Tabs
        activeKey={activeTabKey}
        items={items}
        onChange={handleTabChange}
        tabBarStyle={{
          backgroundColor: "var(--color-primary)",
          height: "45px",
          marginBottom: 0,
          padding: "12px 0px",
        }}
        className="custom-tabs mx-[4px] bg-white mb-4 rounded-t-lg rounded-b-lg shadow-md"
        tabBarGutter={0}
      />

      <br />
      <div className="flex justify-end gap-2">
        <ResetButton onClick={() => resetGoals(supplierId, activeTabKey)} />
        <SaveButton onClick={() => saveOrUpdateGoalData(activeTabKey)} disabled={isSaved}/>
        <NextButton isSaved={goalsPillarsStatus[activeTabKey]} onClick={handleNextClick} activeKey={activeTabKey}/>
      </div>
      <br />
    </div>
  );
};

export default React.memo(Goals);